var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsNotEmpty, IsEmail, ValidateIf, IsOptional, IsNumber } from 'class-validator';
var BusinessPaymentDto = /** @class */ (function () {
    function BusinessPaymentDto(groupId) {
        if (groupId) {
            this.groupId = groupId;
        }
        this.hasDifferentInvoiceAddress = false;
    }
    Object.defineProperty(BusinessPaymentDto.prototype, "validateAddress", {
        get: function () {
            return this.hasDifferentInvoiceAddress;
        },
        enumerable: false,
        configurable: true
    });
    BusinessPaymentDto.prototype.toRestModel = function () {
        return {
            group_id: this.groupId,
            name: this.name,
            first_name: this.firstName,
            last_name: this.lastName,
            email: this.email,
            street_name: this.streetName,
            house_number: this.houseNumber,
            city: this.city,
            zip_code: this.zipCode,
        };
    };
    __decorate([
        IsNotEmpty(),
        __metadata("design:type", Number)
    ], BusinessPaymentDto.prototype, "groupId", void 0);
    __decorate([
        ValidateIf(function (model) { return model.validateAddress; }),
        IsNotEmpty(),
        __metadata("design:type", String)
    ], BusinessPaymentDto.prototype, "name", void 0);
    __decorate([
        ValidateIf(function (model) { return model.validateAddress; }),
        IsOptional(),
        __metadata("design:type", String)
    ], BusinessPaymentDto.prototype, "firstName", void 0);
    __decorate([
        ValidateIf(function (model) { return model.validateAddress; }),
        IsOptional(),
        __metadata("design:type", String)
    ], BusinessPaymentDto.prototype, "lastName", void 0);
    __decorate([
        ValidateIf(function (model) { return model.validateAddress; }),
        IsEmail(),
        IsOptional(),
        __metadata("design:type", String)
    ], BusinessPaymentDto.prototype, "email", void 0);
    __decorate([
        ValidateIf(function (model) { return model.validateAddress; }),
        IsNotEmpty(),
        __metadata("design:type", String)
    ], BusinessPaymentDto.prototype, "streetName", void 0);
    __decorate([
        ValidateIf(function (model) { return model.validateAddress; }),
        IsNotEmpty(),
        __metadata("design:type", String)
    ], BusinessPaymentDto.prototype, "houseNumber", void 0);
    __decorate([
        ValidateIf(function (model) { return model.validateAddress; }),
        IsNotEmpty(),
        __metadata("design:type", String)
    ], BusinessPaymentDto.prototype, "city", void 0);
    __decorate([
        ValidateIf(function (model) { return model.validateAddress; }),
        IsNumber(),
        __metadata("design:type", Number)
    ], BusinessPaymentDto.prototype, "zipCode", void 0);
    return BusinessPaymentDto;
}());
export { BusinessPaymentDto };
